import { NgStyle } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { IconName } from '@app/core/models/icons.model';
import { IconComponent } from '../icon/icon.component';

export type StatusIconColors = 'green' | 'yellow' | 'red' | 'blue';
const mapping: Record<string, IconName> = {
  green: 'check-circle',
  yellow: 'alert-triangle',
  red: 'alert-polygon',
  blue: 'alert-info',
};
@Component({
  selector: 'adspt-status-icon',
  templateUrl: './status-icon.component.html',
  styleUrls: ['./status-icon.component.scss'],
  imports: [NgStyle, IconComponent],
})
export class StatusIconComponent {
  readonly color = input<StatusIconColors>();
  readonly size = input(21);
  readonly icon = computed<IconName>(() => mapping[this.color()]);
}
